export default "__VITE_ASSET__CXfMdIeM__"